<!-- 用一个更好的方式服务企业 -->
<template>
  <div class="e_world">
    <div class="styleBox_04">
      <ul>
        <li :style="{backgroundImage:'url('+ bgUrl +')'}">
          <img
            class="boxLogo"
            :src="baseImgUrl + '/u/20230101/1网络服务@2x_1672574823005.png'"
          />
          <h4>
            Network as a Service
            <img :src="baseImgUrl + '/u/20230101/装饰条@2x_1672574823009.png'" />
          </h4>
          <p>Centralized control of global high-quality network resources, integrated SDP/S centralized control of global high-quality network resources, integrated SDP/S centralized control of global high-quality network resources, integrated SDP/S centralized control of global high-quality network resources, integrated SDP/S centralized control of global high-quality network resources, integrated SDP/S</p>
        </li>
        <li :style="{backgroundImage:'url('+ bgUrl +')'}">
          <img
            class="boxLogo"
            :src="baseImgUrl + '/u/20230101/2信任安全@2x_1672574823006.png'"
          />
          <h4>
            Zero Trust Security
            <img :src="baseImgUrl + '/u/20230101/装饰条@2x_1672574823009.png'" />
          </h4>
          <p>Integrate the entire stack of security facilities with your clients and servers in the same network. Protect all traffic of access services, and protect all servers and resource facilities of access services. Everywhere Network Security Protection You can securely access it from anywhere in the world.</p>
        </li>
        <li :style="{backgroundImage:'url('+ bgUrl +')'}">
          <img
            class="boxLogo"
            :src="baseImgUrl + '/u/20230101/3用户体验@2x_1672574823007.png'"
          />
          <h4>
            Consistent user experience
            <img :src="baseImgUrl + '/u/20230101/装饰条@2x_1672574823009.png'" />
          </h4>
          <p>A unified data fast forwarding layer seamlessly connects to your server. Distributed nearby network access points can avoid performance bottlenecks caused by centralized user access, and implement intelligent, dynamic, and hierarchical management in combination with user terminal devices, allowing users to remain unaware even when attacked.</p>
        </li>
        <li :style="{backgroundImage:'url('+ bgUrl +')'}">
          <img
            class="boxLogo"
            :src="baseImgUrl + '/u/20230101/4一站服务@2x_1672574823008.png'"
          />
          <h4>
            One-stop service
            <img :src="baseImgUrl + '/u/20230101/装饰条@2x_1672574823009.png'" />
          </h4>
          <p>In any case, the operation and maintenance management of the Global Overlay Network platform is always the responsibility of Meg Network, and all of this is reliable, monitored, and manageable, and can evolve with the development of your business. You only need to focus on your business logic itself.</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      baseImgUrl: '',
      bgUrl: ''
    }
  },
  methods: {
  },
  created () {
  },
  mounted () {
    this.baseImgUrl = this.$axios.defaults.baseURL
    this.bgUrl = this.$axios.defaults.baseURL + '/u/20230101/service_bg_1672575021908.png'
  },
  computed: {
  }
}
</script>
<style lang="less" scoped>
@media only screen and (min-width: 1024px) {
  .styleBox_04 {
    display: flex;
    max-width: 1180px;
    margin: 0 auto;
  }

  .styleBox_04 ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .styleBox_04 ul li {
    width: 45%;
    box-sizing: border-box;
    position: relative;
    padding: 113px 31px 46px;
    text-align: left;
    background-repeat: no-repeat;
    background-size: 99% 99%;
    margin-bottom: 59px;
    transition: all 0.4s;
    -moz-transition: all 0.4s;
    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
  }

  .styleBox_04 ul li:hover {
    transform: scale(0.99);
    cursor: pointer;
  }

  .styleBox_04 ul li:hover .boxLogo {
    transform: scale(1.2);
  }

  .styleBox_04 ul li .boxLogo {
    width: 112px;
    height: 100px;
    position: absolute;
    right: 50px;
    top: 32px;
    transition: all 0.4s;
    -moz-transition: all 0.4s;
    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
  }

  .styleBox_04 ul li h4 {
    font-size: 22px;
    font-weight: 600;
    color: #353535;
    line-height: 30px;
    margin-bottom: 32px;
  }

  .styleBox_04 ul li h4 img {
    width: 24px;
    height: 18px;
    transition: all 0.4s;
    -moz-transition: all 0.4s;
    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
  }

  .styleBox_04 ul li:hover img {
    transform: translateX(46px);
  }

  .styleBox_04 ul li p {
    font-size: 16px;
    font-weight: 400;
    color: #4c5461;
    line-height: 30px;
    text-align: left;
  }
}

@media only screen and (max-width: 1024px) {
  .styleBox_04 {
    display: flex;
    max-width: 1180px;
    margin: 0 auto;
    padding: 0 1.315rem;
    box-sizing: border-box;
  }

  .styleBox_04 ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    padding: 0;
  }

  .styleBox_04 ul li {
    width: 100%;
    box-sizing: border-box;
    position: relative;
    padding: 1.6875rem 2.125rem 1.75rem;
    text-align: left;
    background-repeat: no-repeat;
    background-size: 99% 99%;
    margin-bottom: 1.125rem;
    transition: all 0.4s;
    -moz-transition: all 0.4s;
    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
  }

  .styleBox_04 ul li:hover {
    transform: scale(0.99);
    cursor: pointer;
  }

  .styleBox_04 ul li:hover .boxLogo {
    transform: scale(1.2);
  }

  .styleBox_04 ul li .boxLogo {
    width: 4.375rem;
    height: 3.9375rem;
    position: absolute;
    right: 1.9375rem;
    top: 1.6875rem;
    transition: all 0.4s;
    -moz-transition: all 0.4s;
    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
  }

  .styleBox_04 ul li h4 {
    font-size: 1rem;
    font-weight: 600;
    color: #353535;
    line-height: 1rem;
    margin-bottom: 1.375rem;
    padding-top: 2.0625rem;
  }

  .styleBox_04 ul li h4 img {
    width: 1rem;
    height: 0.8rem;
    transition: all 0.4s;
    -moz-transition: all 0.4s;
    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
  }

  .styleBox_04 ul li:hover img {
    transform: translateX(46px);
  }

  .styleBox_04 ul li p {
    font-size: 0.875rem;
    font-weight: 400;
    color: #4c5461;
    line-height: 1.375rem;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comForPc/English_model/E_service.vue